@if (inited) {
    <div class="height100p flex-col-fixed-fill">
        <sm-toolbar>
            <p-button [disabled]="!isChanged()" icon="fas fa-save" label="Speichern" (onClick)="save()">
            </p-button>
            <p-button icon="fas fa-plus" label="Neu" (onClick)="add()">
            </p-button>
        </sm-toolbar>
        <sm-table [data]="table" [allowRemoveRow]=true [handleRemove]=true></sm-table>
    </div>
}